/* UltimateKicks — plus layer
   Instant search, sticky buy bar, size guide, recently viewed, header saved
   counter, share, scroll progress, compact header, back to top, hero light,
   magnetic buttons, wall wheel support, and a small easter egg. */
(function () {
  if (window.ukPlusLoaded) return;
  window.ukPlusLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function read(key, fallback) {
    try { var v = localStorage.getItem(key); return v === null ? fallback : JSON.parse(v); } catch (e) { return fallback; }
  }
  function write(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {} }
  function toast(msg, linkText, href) { if (window.ukToast) window.ukToast(msg, linkText, href); }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function productData() {
    var n = document.getElementById('uk-product-data');
    if (!n) return null;
    try { return JSON.parse(n.textContent); } catch (e) { return null; }
  }
  function cleanSize(v) { return (v || '').replace(/^[A-Za-z]+\s*/, '').trim(); }
  function formatMoney(value) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var n = parseFloat(value);
    if (isNaN(n)) return value;
    try { return new Intl.NumberFormat('es-ES', { style: 'currency', currency: cur }).format(n); }
    catch (e) { return n.toFixed(2) + ' ' + cur; }
  }
  var ICON_SEARCH = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.6-3.6"/></svg>';
  var ICON_HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3 4.6 13.1a4.9 4.9 0 0 1 6.9-7l.5.5.5-.5a4.9 4.9 0 0 1 6.9 7Z"/></svg>';

  /* =========================================================
     1. Scroll: progress bar, compact header, back to top
     ========================================================= */
  function bootScroll() {
    var bar = el('div', 'uk-progress');
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);

    var top = el('button', 'uk-top');
    top.type = 'button';
    top.setAttribute('aria-label', 'Volver arriba');
    top.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    top.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    document.body.appendChild(top);

    var ticking = false;
    function update() {
      ticking = false;
      var y = window.scrollY || 0;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, y / max) : 0) + ')';
      document.body.classList.toggle('uk-scrolled', y > 40);
      top.classList.toggle('is-on', y > window.innerHeight * 1.5);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* =========================================================
     2. Header saved counter (heart next to the bag)
     ========================================================= */
  function bootSavedLink() {
    var actions = $('header-actions');
    if (!actions || $('.uk-saved-link')) return;
    var a = el('a', 'uk-saved-link header-actions__action');
    a.href = '/pages/the-wall?saved=1';
    a.innerHTML = ICON_HEART + '<span class="uk-saved-link__count"></span>';
    function paint() {
      var n = (window.ukStore ? window.ukStore.getSaved() : read('uk-saved', [])).length;
      a.querySelector('.uk-saved-link__count').textContent = n || '';
      a.classList.toggle('has-items', n > 0);
      a.setAttribute('aria-label', n ? 'Pares guardados (' + n + ')' : 'Pares guardados');
    }
    paint();
    actions.insertBefore(a, actions.firstChild);
    document.addEventListener('uk:saved', function () {
      paint();
      if (!reduceMotion) { a.classList.remove('is-bump'); void a.offsetWidth; a.classList.add('is-bump'); }
    });
  }

  /* =========================================================
     3. Instant search
     ========================================================= */
  var POPULAR = ['Jordan 4', 'Travis Scott', 'One Piece', 'Samba', 'Pokémon'];
  var search = null;

  function buildSearch() {
    var wrap = el('div', 'uk-search');
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-label', 'Buscar productos');
    wrap.hidden = true;
    wrap.innerHTML =
      '<div class="uk-search__backdrop" data-close></div>' +
      '<div class="uk-search__panel">' +
        '<form class="uk-search__bar" role="search" action="/search" method="get">' +
          '<span class="uk-search__icon">' + ICON_SEARCH + '</span>' +
          '<input type="search" name="q" autocomplete="off" spellcheck="false" placeholder="Busca sneakers, marcas o códigos de estilo" aria-label="Buscar" aria-controls="uk-search-results">' +
          '<input type="hidden" name="type" value="product">' +
          '<button type="button" class="uk-search__close" data-close aria-label="Cerrar búsqueda">Esc</button>' +
          '<span class="uk-search__scan" aria-hidden="true"></span>' +
        '</form>' +
        '<div class="uk-search__body">' +
          '<div class="uk-search__idle"></div>' +
          '<ul class="uk-search__results" id="uk-search-results" role="listbox" aria-label="Resultados"></ul>' +
          '<p class="uk-search__empty" hidden></p>' +
          '<a class="uk-search__all" hidden></a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(wrap);

    var input = $('input[type="search"]', wrap);
    var results = $('.uk-search__results', wrap);
    var idle = $('.uk-search__idle', wrap);
    var empty = $('.uk-search__empty', wrap);
    var allLink = $('.uk-search__all', wrap);
    var form = $('form', wrap);
    var controller = null;
    var timer = null;
    var active = -1;
    var lastFocus = null;

    function recent() { return read('uk-recent-q', []); }
    function remember(q) {
      q = q.trim();
      if (!q) return;
      var list = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      list.unshift(q);
      write('uk-recent-q', list.slice(0, 5));
    }

    function chipRow(title, words) {
      if (!words.length) return '';
      return '<p class="uk-search__label">' + title + '</p><div class="uk-search__chips">' +
        words.map(function (w) {
          var safe = String(w).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
          return '<button type="button" class="uk-search__chip" data-q="' + safe + '">' + safe + '</button>';
        }).join('') + '</div>';
    }
    function paintIdle() {
      idle.innerHTML = chipRow('Búsquedas recientes', recent()) + chipRow('Lo más buscado', POPULAR);
    }

    function setActive(i) {
      var items = $$('.uk-search__item', results);
      if (!items.length) { active = -1; return; }
      active = (i + items.length) % items.length;
      items.forEach(function (it, n) { it.setAttribute('aria-selected', n === active ? 'true' : 'false'); });
      items[active].scrollIntoView({ block: 'nearest' });
      input.setAttribute('aria-activedescendant', items[active].id);
    }

    function render(q, products) {
      results.innerHTML = '';
      active = -1;
      input.removeAttribute('aria-activedescendant');
      var mySize = window.ukStore ? window.ukStore.getSize() : '';
      products.forEach(function (p, i) {
        var li = el('li', 'uk-search__item');
        li.id = 'uk-sr-' + i;
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        var a = el('a', 'uk-search__link');
        a.href = p.url;
        var box = el('span', 'uk-search__box');
        if (p.image) {
          var img = el('img');
          img.src = p.image + (p.image.indexOf('?') === -1 ? '?' : '&') + 'width=300';
          img.alt = '';
          img.loading = 'lazy';
          box.appendChild(img);
        }
        a.appendChild(box);
        a.appendChild(el('span', 'uk-search__vendor', p.vendor || ''));
        a.appendChild(el('span', 'uk-search__title', p.title));
        a.appendChild(el('span', 'uk-search__price', 'Desde ' + formatMoney(p.price)));
        if (mySize && p.variants && p.variants.some(function (v) { return v.available && cleanSize(v.title) === mySize; })) {
          box.appendChild(el('span', 'uk-search__fit', 'EU ' + mySize + ' disponible'));
        }
        a.addEventListener('click', function () { remember(q); });
        li.appendChild(a);
        results.appendChild(li);
      });
      var none = products.length === 0;
      empty.hidden = !none;
      if (none) empty.textContent = 'No hemos encontrado pares para "' + q + '". Prueba con una marca como Jordan o un código de estilo.';
      idle.hidden = !none;
      if (none) paintIdle();
      allLink.hidden = none;
      allLink.href = '/search?type=product&q=' + encodeURIComponent(q);
      allLink.textContent = 'Ver todos los resultados de "' + q + '"';
    }

    function run(q) {
      if (controller) controller.abort();
      if (!q.trim()) {
        results.innerHTML = ''; empty.hidden = true; allLink.hidden = true; idle.hidden = false;
        wrap.classList.remove('is-loading');
        paintIdle();
        return;
      }
      controller = window.AbortController ? new AbortController() : null;
      wrap.classList.add('is-loading');
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (data) {
          wrap.classList.remove('is-loading');
          var list = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          render(q, list);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          wrap.classList.remove('is-loading');
          render(q, []);
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value;
      timer = setTimeout(function () { run(q); }, 180);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Enter' && active > -1) {
        e.preventDefault();
        var link = $$('.uk-search__link', results)[active];
        if (link) { remember(input.value); window.location.href = link.href; }
      }
    });
    form.addEventListener('submit', function () { remember(input.value); });
    wrap.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) { close(); return; }
      var chip = e.target.closest('.uk-search__chip');
      if (chip) { input.value = chip.getAttribute('data-q'); run(input.value); input.focus(); }
    });
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      if (e.key === 'Tab') {
        var f = $$('input[type="search"], button, a[href]', wrap).filter(function (n) { return n.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });

    function open(prefill) {
      lastFocus = document.activeElement;
      wrap.hidden = false;
      document.documentElement.classList.add('uk-search-open');
      requestAnimationFrame(function () { wrap.classList.add('is-open'); });
      if (prefill) input.value = prefill;
      run(input.value);
      setTimeout(function () { input.focus(); input.select(); }, 30);
    }
    function close() {
      wrap.classList.remove('is-open');
      document.documentElement.classList.remove('uk-search-open');
      setTimeout(function () { wrap.hidden = true; }, reduceMotion ? 0 : 200);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    return { open: open, close: close };
  }

  function bootSearch() {
    search = buildSearch();
    // "/" opens search anywhere (unless typing in a field)
    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
      var t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      e.preventDefault();
      search.open();
    });
    // Take over the header search icon
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest(
        '#header-component a[href*="/search"], #header-component search-button, #header-component .search-action,' +
        '#header-component button[aria-label*="earch" i], #header-component button[aria-label*="uscar" i],' +
        '[data-uk-search-open]'
      );
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      search.open();
    }, true);
  }

  /* =========================================================
     4. Recently viewed
     ========================================================= */
  function trackRecent(d) {
    if (!d || !d.handle) return;
    var list = read('uk-recent', []).filter(function (x) { return x.h !== d.handle; });
    list.unshift({ h: d.handle, t: d.title, i: d.image, p: d.priceMin, u: d.url });
    write('uk-recent', list.slice(0, 12));
  }

  function renderRecent(currentHandle) {
    var main = $('#MainContent');
    if (!main || $('.uk-recent')) return;
    var list = read('uk-recent', []).filter(function (x) { return x.h !== currentHandle && x.i; });
    if (!list.length) return;
    var sec = el('section', 'uk-recent');
    sec.setAttribute('aria-label', 'Vistos recientemente');
    var head = el('div', 'uk-recent__head');
    head.appendChild(el('h2', 'uk-sec-title', 'Vistos recientemente'));
    var clear = el('button', 'uk-recent__clear', 'Borrar');
    clear.type = 'button';
    clear.addEventListener('click', function () {
      write('uk-recent', []);
      sec.remove();
      toast('Historial borrado');
    });
    head.appendChild(clear);
    var inner = el('div', 'uk-wrap');
    inner.appendChild(head);
    var row = el('div', 'uk-recent__row');
    list.forEach(function (x) {
      var a = el('a', 'uk-recent__item');
      a.href = x.u;
      var box = el('span', 'uk-recent__box');
      var img = el('img');
      img.src = x.i; img.alt = ''; img.loading = 'lazy';
      box.appendChild(img);
      a.appendChild(box);
      a.appendChild(el('span', 'uk-recent__title', x.t));
      a.appendChild(el('span', 'uk-recent__price', 'Desde ' + x.p));
      row.appendChild(a);
    });
    inner.appendChild(row);
    sec.appendChild(inner);
    main.appendChild(sec);
  }

  /* =========================================================
     5. Product page: sticky buy bar, size guide, share
     ========================================================= */
  function selectedSize() {
    var c = $('variant-picker input[type="radio"]:checked');
    return c ? cleanSize(c.value) : '';
  }
  function variantFor(d, size) {
    for (var i = 0; i < d.variants.length; i++) if (d.variants[i].size === size) return d.variants[i];
    return null;
  }
  function mainAddButton() {
    var btns = $$('#MainContent button[name="add"], #MainContent .add-to-cart-button');
    for (var i = 0; i < btns.length; i++) if (!btns[i].closest('.quick-add') && !btns[i].closest('.uk-buybar')) return btns[i];
    return null;
  }

  function bootBuyBar(d) {
    var real = mainAddButton();
    if (!real || !window.IntersectionObserver) return;
    var bar = el('div', 'uk-buybar');
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<span class="uk-buybar__img"></span>' +
      '<span class="uk-buybar__info"><span class="uk-buybar__title"></span><span class="uk-buybar__meta"></span></span>' +
      '<button type="button" class="uk-btn uk-btn--orange uk-buybar__btn" tabindex="-1">Agregar al carrito</button>';
    if (d.image) {
      var img = el('img'); img.src = d.image; img.alt = '';
      $('.uk-buybar__img', bar).appendChild(img);
    }
    $('.uk-buybar__title', bar).textContent = d.title;
    document.body.appendChild(bar);
    var btn = $('.uk-buybar__btn', bar);

    function paint() {
      var size = selectedSize();
      var v = size ? variantFor(d, size) : null;
      var meta = $('.uk-buybar__meta', bar);
      if (v) {
        meta.textContent = (d.type === 'Sneakers' ? 'EU ' : 'Talla ') + size + ' — ' + v.price;
        btn.disabled = !v.available;
        btn.textContent = v.available ? 'Agregar al carrito' : 'Agotado';
      } else {
        meta.textContent = 'Desde ' + d.priceMin;
        btn.disabled = false;
        btn.textContent = 'Elige talla';
      }
    }
    btn.addEventListener('click', function () {
      if (!selectedSize()) {
        var picker = $('variant-picker');
        if (picker) picker.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      var r = mainAddButton();
      if (r) r.click();
    });
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-picker')) setTimeout(paint, 60);
    });
    paint();

    var io = new IntersectionObserver(function (entries) {
      var off = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-on', off);
      bar.setAttribute('aria-hidden', off ? 'false' : 'true');
      btn.tabIndex = off ? 0 : -1;
      document.body.classList.toggle('uk-buybar-on', off);
    });
    io.observe(real);
  }

  function formatSize(n) {
    var r = Math.round(n * 2) / 2;
    var s = r.toFixed(1);
    return s.slice(-2) === '.0' ? s.slice(0, -2) : s;
  }
  function sizeNum(s) {
    var m = s.match(/^(\d+)\s+(1|2)\/3$/);
    if (m) return parseFloat(m[1]) + (m[2] === '1' ? 1 / 3 : 2 / 3);
    return parseFloat(String(s).replace(',', '.'));
  }

  function bootSizeGuide(d) {
    if (d.type !== 'Sneakers') return;
    var toggle = $('[data-size-unit-toggle]');
    if (!toggle || $('.uk-guide-btn', toggle)) return;
    var btn = el('button', 'uk-guide-btn', 'Guía de tallas');
    btn.type = 'button';
    toggle.appendChild(btn);

    var dlg = $('.uk-guide');
    if (!dlg) {
      dlg = el('dialog', 'uk-guide');
      dlg.setAttribute('aria-label', 'Guía de tallas');
      var rows = d.variants.map(function (v) {
        var eu = sizeNum(v.size);
        if (isNaN(eu)) return '';
        var cm = (eu / 1.5 - 1.5).toFixed(1);
        return '<tr' + (v.available ? '' : ' class="is-out"') + '><td>' + v.size + '</td><td>' + formatSize(eu - 34) +
          '</td><td>' + formatSize(eu - 33) + '</td><td>' + cm + '</td></tr>';
      }).join('');
      dlg.innerHTML =
        '<div class="uk-guide__head"><h2>Guía de tallas</h2><button type="button" class="uk-guide__close" aria-label="Cerrar">&times;</button></div>' +
        '<p class="uk-guide__note">Equivalencia aproximada para ' + (d.vendor || 'este par') + '. El tallaje puede variar entre marcas y modelos: si dudas entre dos tallas, escríbenos antes de hacer el pedido.</p>' +
        '<div class="uk-guide__scroll"><table><thead><tr><th>EU</th><th>UK</th><th>US</th><th>Pie (cm)</th></tr></thead><tbody>' + rows + '</tbody></table></div>';
      document.body.appendChild(dlg);
      $('.uk-guide__close', dlg).addEventListener('click', function () { dlg.close ? dlg.close() : dlg.removeAttribute('open'); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg && dlg.close) dlg.close(); });
    }
    btn.addEventListener('click', function () {
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    });
  }

  function bootShare(d) {
    var label = $('[data-uk-pdp-label]');
    if (!label || $('.uk-share', label)) return;
    var btn = el('button', 'uk-share', 'Compartir este par');
    btn.type = 'button';
    btn.addEventListener('click', function () {
      var url = window.location.origin + d.url;
      if (navigator.share) {
        navigator.share({ title: d.title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () { toast('Enlace copiado'); }, function () {});
      }
    });
    label.appendChild(btn);
  }

  /* =========================================================
     6. Homepage: hero light, magnetic buttons
     ========================================================= */
  function bootHero() {
    var hero = $('.uk-hero');
    if (!hero || reduceMotion || !finePointer) return;
    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      hero.style.setProperty('--hx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      hero.style.setProperty('--hy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    });
    $$('.uk-btn').forEach(function (b) {
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / (r.width / 2);
        var y = (e.clientY - r.top - r.height / 2) / (r.height / 2);
        b.style.transform = 'translate(' + (x * 5).toFixed(1) + 'px,' + (y * 4).toFixed(1) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* =========================================================
     7. The Wall: trackpad swipe, keyboard hint, ?saved=1
     ========================================================= */
  function bootWallExtras() {
    $$('[data-uk-wall]').forEach(function (wall) {
      var stage = $('.uk-wall__stage', wall);
      var next = $('[data-wall-next]', wall);
      var prev = $('[data-wall-prev]', wall);
      if (stage && next && prev) {
        var lock = 0;
        stage.addEventListener('wheel', function (e) {
          if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || Math.abs(e.deltaX) < 8) return;
          e.preventDefault();
          var now = Date.now();
          if (now - lock < 180) return;
          lock = now;
          (e.deltaX > 0 ? next : prev).click();
        }, { passive: false });
      }
      var controls = $('.uk-wall__controls', wall);
      if (controls && finePointer && !$('.uk-wall__hint', wall)) {
        var hint = el('p', 'uk-wall__hint', 'Consejo: arrastra la estantería o usa las teclas \u2190 \u2192');
        controls.insertAdjacentElement('afterend', hint);
      }
    });
    if (/[?&]saved=1/.test(window.location.search)) {
      var btn = $('[data-wall-saved]');
      if (btn && btn.getAttribute('aria-pressed') !== 'true') btn.click();
    }
  }

  /* =========================================================
     8. Easter egg: type "grail"
     ========================================================= */
  function bootEgg() {
    var typed = '';
    document.addEventListener('keydown', function (e) {
      var t = e.target;
      if (t && /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return;
      if (!e.key || e.key.length !== 1) return;
      typed = (typed + e.key.toLowerCase()).slice(-5);
      if (typed !== 'grail') return;
      typed = '';
      toast('¡Has encontrado un grail!');
      if (reduceMotion) return;
      var colors = ['#FF5A1F', '#2448D8', '#F7C8D6', '#16181D'];
      for (var i = 0; i < 44; i++) {
        var c = el('span', 'uk-confetti');
        c.style.left = Math.random() * 100 + 'vw';
        c.style.background = colors[i % colors.length];
        c.style.animationDelay = Math.random() * 0.4 + 's';
        c.style.setProperty('--drift', (Math.random() * 200 - 100).toFixed(0) + 'px');
        c.style.setProperty('--spin', (Math.random() * 720 - 360).toFixed(0) + 'deg');
        document.body.appendChild(c);
        setTimeout(function (n) { return function () { n.remove(); }; }(c), 2200);
      }
    });
  }

  /* =========================================================
     Boot
     ========================================================= */
  function boot() {
    bootScroll();
    bootSavedLink();
    bootSearch();
    bootHero();
    bootEgg();
    // The Wall initialises after this script, so wait for the document to finish.
    if (document.readyState === 'complete') bootWallExtras();
    else document.addEventListener('DOMContentLoaded', bootWallExtras);

    var d = productData();
    if (d) {
      trackRecent(d);
      bootBuyBar(d);
      bootSizeGuide(d);
      // The label is injected by uk-fx.js; wait a frame for it.
      requestAnimationFrame(function () { bootShare(d); });
    }
    var mainEl = $('#MainContent');
    var tpl = mainEl ? mainEl.getAttribute('data-template') || '' : '';
    if (/^(index|product|collection)/.test(tpl)) renderRecent(d ? d.handle : '');

    // Theme re-renders can drop our additions; put them back.
    if (window.MutationObserver && d) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          bootSizeGuide(d);
          bootShare(d);
        });
      }).observe($('#MainContent') || document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
